import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-popup-referred-profileupdated',
  templateUrl: './popup-referred-profileupdated.component.html',
  styleUrls: ['./popup-referred-profileupdated.component.sass']
})
export class PopupReferredProfileupdatedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
